import * as React from "react";

const FilterIcon = (props) => (
  <svg
    viewBox="0 0 21 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      d="M8.167 14h4.666v-2.333H8.167V14ZM0 0v2.333h21V0H0Zm3.5 8.167h14V5.833h-14v2.334Z"
      fill="currentColor"
    />
  </svg>
);

export default FilterIcon;
